var app = angular.module("leonardo");

var ManagementCompaniesDialog = function($scope, $timeout, $rootScope, $filter, $q, AccountUserService, PermissionService,
                                         AuthDataService) {

  $scope.action = $scope.ngDialogData.action;
  $scope.initRol = false;
  $scope.accounts = [];
  $scope.roles = [];
  $scope.managed = null;
  $scope.accountUserService = AccountUserService;
  $scope.authDataService = AuthDataService;

  $scope.managed_by_account_users = $scope.ngDialogData.managed_by_account_users ? angular.copy($scope.ngDialogData.managed_by_account_users) : {
    account: {},
    role: '',
    categories: [],
    properties_account: {
      portfolios: [],
      properties: []
    },
    report_to: '',
    managed_by: $scope.ngDialogData.managed_by,
    user: $scope.ngDialogData.user_id
  };

  if ($scope.managed_by_account_users.portfolios || $scope.managed_by_account_users.properties)
    $scope.managed_by_account_users.properties_account = {
      portfolios: angular.copy($scope.managed_by_account_users.portfolios),
      properties: angular.copy($scope.managed_by_account_users.properties)
    };

  $scope.accounts_for_new_account_users = $scope.ngDialogData.accounts_for_new_account_users;

  $scope.account = $scope.ngDialogData.managed_by_account_users ? $scope.ngDialogData.managed_by_account_users.account : undefined;
  $scope.accountObj = $scope.ngDialogData.accountObj;

  angular.forEach(AuthDataService.authData.accountsManager, function (manager) {
    if (_.contains($scope.accounts_for_new_account_users, manager.id)) {
      $scope.accounts.push(manager);
      if ($scope.account == manager.id) {
        $scope.managed = manager;
      }
    }
  });

  if (!isNull($scope.managed_by_account_users.role)) {
    $timeout(function () {
      $scope.initRol = true;
    }, 0);
  }

  $scope.getUsersReportTo = function (params) {
    var account_user = AccountUserService.getAccountUser($scope.account);
    return AccountUserService.getUsersReportTo(account_user.id, params);
  };

  $scope.$watch('account', function (newValue, oldValue) {
    if ((newValue != oldValue) || (newValue && $scope.ngDialogData.managed_by_account_users)) {
      $scope.roles = AuthDataService.getRolesValid($scope.account, true);

      angular.forEach(AuthDataService.authData.accountsManager, function (manager) {
        if (manager.id == $scope.account) {
          $scope.managed = manager;
          $scope.managed_by_account_users.account = manager.id;
        }
      });
    }
  });

  $scope.isRoleOwner = function (role) {
    var isOwner = false;
    angular.forEach($scope.roles, function (item) {
      if (role == item.id) {
        isOwner = (item.parent == 1);
      }
    });
    return isOwner;
  };

  $scope.$watch('managed_by_account_users.role', function (newValue, oldValue) {
    if (newValue != oldValue && ($scope.initRol || ($scope.action === 'create'))) {
      if ($scope.isRoleOwner($scope.managed_by_account_users.role)) {
        $scope.managed_by_account_users.portfolios = [];
        $scope.managed_by_account_users.properties = [];
        $timeout(function(){
          $rootScope.$broadcast('select-properties-all:updated');
        }, 0);
      }
      $q.when($scope.roles).then(function (data) {
        var roles = data.results ? data.results : data;
        angular.forEach(roles, function (role) {
          if (role.id == newValue) {
            if (role.categories && role.categories.length > 0) {
              $scope.managed_by_account_users.categories = [];
              $timeout(function(){
                var ids = [];
                angular.forEach(role.categories, function (category) {
                  ids.push(category.id ? category.id : category);
                });
                $scope.managed_by_account_users.categories = ids;
              }, 0);
            }
            angular.forEach(role.permissions, function (value, key) {
              if (_.includes(key, 'permission_') && PermissionService.permissionAvailable(key, $scope.managed_by_account_users) && (oldValue || !$scope.managed_by_account_users.id)) {
                $scope.managed_by_account_users[key] = value;
              }
              else {
                $scope.managed_by_account_users[key] = false;
              }
            });
          }
        });
        $scope.initRol = true;
      });
    }
  });

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) return;
    if ($scope.managed_by_account_users.properties_account) {
      $scope.managed_by_account_users.portfolios = angular.copy($scope.managed_by_account_users.properties_account.portfolios);
      $scope.managed_by_account_users.properties = angular.copy($scope.managed_by_account_users.properties_account.properties);
      delete($scope.managed_by_account_users.properties_account);
    }
    $scope.confirm($scope.managed_by_account_users);
  };

};

app.controller('ManagementCompaniesDialog', ['$scope', '$timeout', '$rootScope', '$filter', '$q', 'AccountUserService',
  'PermissionService', 'AuthDataService',  ManagementCompaniesDialog]);
